<div class="ai-page d-flex flex-column min-vh-100">

	<!-- Loading -->
	<div *ngIf="loadingInvite" class="ai-state d-flex flex-fill flex-column align-items-center justify-content-center text-center gap-2">
		<p class="portal-muted">Loading your invitation…</p>
	</div>

	<!-- Invalid / expired -->
	<div *ngIf="!loadingInvite && loadError" class="ai-state d-flex flex-fill flex-column align-items-center justify-content-center text-center gap-2">
		<h1 class="ai-brand">{{ product }}</h1>
		<div class="portal-error">{{ loadError }}</div>
		<a class="btn btn-outline-secondary mt-2" routerLink="/login">Go to sign in</a>
	</div>

	<ng-container *ngIf="!loadingInvite && invite">

		<!-- Hero -->
		<section class="ai-hero position-relative">
			<div class="ai-hero-inner w-100 mx-auto text-center">
				<h1 class="ai-brand">{{ product }}.</h1>

				<div class="ai-confirmed d-inline-flex align-items-center">
					<span>Confirmed as {{ invite.email }}</span>
					<a class="ai-change" (click)="signIn()">Change</a>
				</div>

				<p class="ai-invite-line">
					Join {{ product }} to view {{ projectName }}.<br />
					<ng-container *ngIf="inviterName">You were invited by {{ inviterName }} from {{ orgName }}.</ng-container>
					<ng-container *ngIf="!inviterName">You were invited to join {{ orgName }}.</ng-container>
				</p>

				<!-- Step 1: continue -->
				<ng-container *ngIf="step === 'intro'">
					<button type="button" class="btn btn-primary btn-block ai-cta mx-auto" (click)="continue()">Continue</button>
				</ng-container>

				<!-- Step 2: create a password -->
				<ng-container *ngIf="step === 'password'">
					<p class="ai-password-line">Create a password for {{ invite.email }} to continue.</p>

					<form class="ai-form w-100 mx-auto text-left" (ngSubmit)="submit()">
						<div class="ai-name-row d-flex">
							<div class="form-group flex-fill">
								<label for="firstName">First name</label>
								<input id="firstName" class="form-control" type="text" name="firstName" placeholder="First name"
									[(ngModel)]="firstName" autocomplete="given-name" />
							</div>
							<div class="form-group flex-fill">
								<label for="lastName">Last name</label>
								<input id="lastName" class="form-control" type="text" name="lastName" placeholder="Last name"
									[(ngModel)]="lastName" autocomplete="family-name" />
							</div>
						</div>

						<div class="form-group">
							<label for="email">E-mail</label>
							<input id="email" class="form-control" type="email" [value]="invite.email" disabled />
						</div>

						<div class="form-group">
							<label for="password">Password</label>
							<input id="password" class="form-control" type="password" name="password" placeholder="Enter Password"
								[(ngModel)]="password" autocomplete="new-password" />
						</div>

						<div class="form-group">
							<label for="passwordConf">Confirm Password</label>
							<input id="passwordConf" class="form-control" type="password" name="passwordConf" placeholder="Enter Password"
								[(ngModel)]="passwordConf" autocomplete="new-password" />
						</div>

						<div class="portal-error" *ngIf="error">{{ error }}</div>

						<button type="submit" class="btn btn-primary btn-block ai-cta mx-auto" [disabled]="submitting">
							{{ submitting ? 'Creating…' : 'Create Account' }}
						</button>

						<!-- Beside the button that actually creates the account: Continue on the previous step only
						     reveals this form, so consent attached there bound nothing. -->
						<p class="ai-terms mx-auto text-center">
							By creating your account, you agree to our <button type="button" class="portal-link-button" (click)="termsModal.open()">Terms of Use</button>
							and <button type="button" class="portal-link-button" (click)="privacyModal.open()">Privacy Notice</button>.
						</p>
					</form>

					<button type="button" class="ai-signin-link d-block mx-auto" (click)="signIn()">
						Already have a {{ product }} account? Sign in instead.
					</button>
				</ng-container>
			</div>
		</section>

		<!-- Marketing (intro step only) -->
		<section class="ai-about" *ngIf="step === 'intro'">
			<div class="ai-about-inner d-flex mx-auto">
				<div class="ai-about-copy flex-fill">
					<h2>What's {{ product }}?</h2>
					<p>{{ product }} is a secure portal that helps you stay connected with your project team.</p>
					<p>You can review project documents, quotations, change orders, invoices and updates in one place.</p>
				</div>

				<!-- Decorative only: the copy beside it already says everything this section has to say. -->
				<div class="ai-illustration d-flex flex-fill" aria-hidden="true">
					<img class="ai-illustration-img flex-fill" src="assets/invite_bg.jpeg" alt="" />
				</div>
			</div>
		</section>

		<!-- Footer -->
		<footer class="ai-footer d-flex flex-wrap align-items-center mt-auto">
			<div class="ai-powered d-flex align-items-center gap-2">
				<span>Powered by</span>
				<img class="ai-powered-logo ai-powered-light" src="assets/img/logo/wequote-text-dark.png" alt="WeQuote" />
				<img class="ai-powered-logo ai-powered-dark" src="assets/img/logo/wequote.svg" alt="WeQuote" />
			</div>
			<div class="ai-footer-links d-flex gap-4">
				<button type="button" class="portal-link-button" (click)="termsModal.open()">Terms of Use</button>
				<button type="button" class="portal-link-button" (click)="privacyModal.open()">Privacy Notice</button>
			</div>
		</footer>

	</ng-container>

	<!-- Read-only policy popups, opened from the footer and from the terms line above the Continue button. -->
	<portal-terms-modal #termsModal></portal-terms-modal>
	<portal-privacy-modal #privacyModal></portal-privacy-modal>
</div>
